/* tslint:disable */
/* eslint-disable */
/**
 * Marsello Manage API
 * An API to support POS integrations.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: landon@marsello.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CustomerModel } from '../models';
// @ts-ignore
import { RewardModel } from '../models';
/**
 * PosApi - axios parameter creator
 * @export
 */
export const PosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} customerId 
         * @param {string} rewardId 
         * @param {string} [apiVersion] The requested API version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPosCustomerCustomerIdRewardRewardIdPut: async (customerId: string, rewardId: string, apiVersion?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('apiPosCustomerCustomerIdRewardRewardIdPut', 'customerId', customerId)
            // verify required parameter 'rewardId' is not null or undefined
            assertParamExists('apiPosCustomerCustomerIdRewardRewardIdPut', 'rewardId', rewardId)
            const localVarPath = `/Pos/customer/{customerId}/reward/{rewardId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"rewardId"}}`, encodeURIComponent(String(rewardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} [apiVersion] The requested API version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPosCustomerEmailGet: async (email: string, apiVersion?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('apiPosCustomerEmailGet', 'email', email)
            const localVarPath = `/Pos/customer/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PosApi - functional programming interface
 * @export
 */
export const PosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PosApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} customerId 
         * @param {string} rewardId 
         * @param {string} [apiVersion] The requested API version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPosCustomerCustomerIdRewardRewardIdPut(customerId: string, rewardId: string, apiVersion?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPosCustomerCustomerIdRewardRewardIdPut(customerId, rewardId, apiVersion, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} [apiVersion] The requested API version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPosCustomerEmailGet(email: string, apiVersion?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPosCustomerEmailGet(email, apiVersion, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PosApi - factory interface
 * @export
 */
export const PosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PosApiFp(configuration)
    return {
        /**
         * 
         * @param {string} customerId 
         * @param {string} rewardId 
         * @param {string} [apiVersion] The requested API version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPosCustomerCustomerIdRewardRewardIdPut(customerId: string, rewardId: string, apiVersion?: string, options?: any): AxiosPromise<RewardModel> {
            return localVarFp.apiPosCustomerCustomerIdRewardRewardIdPut(customerId, rewardId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} [apiVersion] The requested API version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPosCustomerEmailGet(email: string, apiVersion?: string, options?: any): AxiosPromise<CustomerModel> {
            return localVarFp.apiPosCustomerEmailGet(email, apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PosApi - object-oriented interface
 * @export
 * @class PosApi
 * @extends {BaseAPI}
 */
export class PosApi extends BaseAPI {
    /**
     * 
     * @param {string} customerId 
     * @param {string} rewardId 
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosApi
     */
    public apiPosCustomerCustomerIdRewardRewardIdPut(customerId: string, rewardId: string, apiVersion?: string, options?: AxiosRequestConfig) {
        return PosApiFp(this.configuration).apiPosCustomerCustomerIdRewardRewardIdPut(customerId, rewardId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosApi
     */
    public apiPosCustomerEmailGet(email: string, apiVersion?: string, options?: AxiosRequestConfig) {
        return PosApiFp(this.configuration).apiPosCustomerEmailGet(email, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}
